import { Injectable } from '@angular/core';
import { XeroApiService } from './xero-api.service';

/**
 * Xero User Information
 */
export interface XeroUserInfo {
  organizationName: string;
  organizationId: string;
  planType: string;
  country: string;
  timezone: string;
  shortCode: string;
  createdAt: string;
  periodLockDate: string;
  endOfYearLockDate: string;
  isDemo: boolean;
}

/**
 * Service for interacting with Xero APIs
 */
@Injectable({
  providedIn: 'root',
})
export class XeroUserService {
  constructor(private xeroApiService: XeroApiService) {}

  /**
   * Fetch Xero user information
   */
  async getUserInfo(): Promise<XeroUserInfo | null> {
    return this.xeroApiService.get<XeroUserInfo>('xero-xeroUser/user', {
      showSuccessToast: true,
      successTitle: 'Xero',
      successMessage: 'Successfully fetched Xero account information',
      actionDescription: 'fetch account information',
    });
  }
}
